<section class="flex flex-col items-center gap-12">
  <app-section-header
    [description]="'Why development teams choose Capawesome Cloud over Capgo'"
    [icon]="'@tui.trophy'"
    [subtitle]="'Key Advantages'"
    [title]="'Complete CI/CD solution, production-ready, expert support'"
  >
  </app-section-header>
  <div class="grid w-full grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
    <!-- Complete CI/CD Solution -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.package" class="mr-2" />
        <h3 class="text-xl font-bold">Complete CI/CD Solution</h3>
      </div>
      <p class="text-pretty text-lg">
        Native Builds, App Store Publishing, and Live Updates — all seamlessly
        integrated in one platform. Streamline your workflow from code to users.
      </p>
    </div>
    <!-- Production Ready -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.check-circle" class="mr-2" />
        <h3 class="text-xl font-bold">Production Ready</h3>
      </div>
      <p class="text-pretty text-lg">
        Fully launched and battle-tested with proven reliability. Deploy with
        confidence knowing thousands of apps trust our infrastructure daily.
      </p>
    </div>
    <!-- Affordable Pricing -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.dollar-sign" class="mr-2" />
        <h3 class="text-xl font-bold">Affordable Pricing</h3>
      </div>
      <p class="text-pretty text-lg">
        Transparent, predictable pricing with no platform multipliers. Get all
        features bundled together for better value and simpler budgeting.
      </p>
    </div>
    <!-- Git Integration -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.git-branch" class="mr-2" />
        <h3 class="text-xl font-bold">Git Integration</h3>
      </div>
      <p class="text-pretty text-lg">
        Automatic builds from GitHub, GitLab, Bitbucket, and Azure DevOps. Push
        your code and let us handle the rest with powerful automation.
      </p>
    </div>
    <!-- Superior Infrastructure -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.server" class="mr-2" />
        <h3 class="text-xl font-bold">Superior Infrastructure</h3>
      </div>
      <p class="text-pretty text-lg">
        M4 instances with temporary VMs for complete isolation, and macOS
        runners for all builds ensuring consistency.
      </p>
    </div>
    <!-- Official Experts -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.award" class="mr-2" />
        <h3 class="text-xl font-bold">Official Experts</h3>
      </div>
      <p class="text-pretty text-lg">
        Team of official Ionic Developer Experts and Capacitor Community Members
        with extensive plugin development experience.
      </p>
    </div>
  </div>
</section>
